var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "assetInfo" },
    [
      _vm.phoneList.length
        ? _c(
            "div",
            { staticClass: "data-title" },
            [
              _c(
                "h3",
                [
                  _vm._v("我的手机工作号"),
                  _c(
                    "el-tag",
                    { staticClass: "tag", attrs: { type: "success" } },
                    [_vm._v(_vm._s(_vm.phoneList.length))]
                  ),
                ],
                1
              ),
              _c("lb-table", {
                directives: [
                  {
                    name: "horizontal-scroll",
                    rawName: "v-horizontal-scroll",
                    value: "always",
                    expression: "'always'",
                  },
                ],
                staticClass: "table",
                attrs: { column: _vm.columns, data: _vm.phoneList },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.wechatList.length
        ? _c(
            "div",
            { staticClass: "data-title" },
            [
              _c(
                "h3",
                [
                  _vm._v("我的工作微信号"),
                  _c(
                    "el-tag",
                    { staticClass: "tag", attrs: { type: "success" } },
                    [_vm._v(_vm._s(_vm.wechatList.length))]
                  ),
                ],
                1
              ),
              _c("lb-table", {
                directives: [
                  {
                    name: "horizontal-scroll",
                    rawName: "v-horizontal-scroll",
                    value: "always",
                    expression: "'always'",
                  },
                ],
                staticClass: "table",
                attrs: { column: _vm.columns1, data: _vm.wechatList },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.qqList.length
        ? _c(
            "div",
            { staticClass: "data-title" },
            [
              _c(
                "h3",
                [
                  _vm._v("我的工作QQ号"),
                  _c(
                    "el-tag",
                    { staticClass: "tag", attrs: { type: "success" } },
                    [_vm._v(_vm._s(_vm.qqList.length))]
                  ),
                ],
                1
              ),
              _c("lb-table", {
                directives: [
                  {
                    name: "horizontal-scroll",
                    rawName: "v-horizontal-scroll",
                    value: "always",
                    expression: "'always'",
                  },
                ],
                staticClass: "table",
                attrs: { column: _vm.columns2, data: _vm.qqList },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.emailList.length
        ? _c(
            "div",
            { staticClass: "data-title" },
            [
              _c(
                "h3",
                [
                  _vm._v("我的工作邮箱"),
                  _c(
                    "el-tag",
                    { staticClass: "tag", attrs: { type: "success" } },
                    [_vm._v(_vm._s(_vm.emailList.length))]
                  ),
                ],
                1
              ),
              _c("lb-table", {
                directives: [
                  {
                    name: "horizontal-scroll",
                    rawName: "v-horizontal-scroll",
                    value: "always",
                    expression: "'always'",
                  },
                ],
                staticClass: "table",
                attrs: { column: _vm.columns3, data: _vm.emailList },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.accountList.length
        ? _c(
            "div",
            { staticClass: "data-title" },
            [
              _c(
                "h3",
                [
                  _vm._v("我的平台账号"),
                  _c(
                    "el-tag",
                    { staticClass: "tag", attrs: { type: "success" } },
                    [_vm._v(_vm._s(_vm.accountList.length))]
                  ),
                ],
                1
              ),
              _c("lb-table", {
                directives: [
                  {
                    name: "horizontal-scroll",
                    rawName: "v-horizontal-scroll",
                    value: "always",
                    expression: "'always'",
                  },
                ],
                staticClass: "table",
                attrs: { column: _vm.columns4, data: _vm.accountList },
              }),
            ],
            1
          )
        : _vm._e(),
      _c("pop-Remark", { ref: "popRemark", on: { setRemark: _vm.saveRemark } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }